export const checkoutButtonEvents = Object.freeze({
  CHECKOUT: 'checkout',
  INSTANT_CHECKOUT: 'instant-checkout'
})
